import { createContext } from 'react';
import { Paths } from 'shared/routes';

import { RouteHistory } from './types';

export type HistoryContextProps = {
  pathStack: Paths[];
  routeStack: RouteHistory[];
};

export const HistoryContext = createContext<HistoryContextProps>({
  pathStack: [],
  routeStack: [],
});
